var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['asc-page-loading-indicator', _vm.loading ? 'loading' : '']},[(_vm.loading)?[_c('v-progress-linear',{attrs:{"bottom":"","indeterminate":"","color":_vm.getColor,"height":4}})]:_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }